import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CustomerInsightService {

  constructor() { }

  generateBlueShades(length: number): string[] {
    if (length <= 0) {
      return [];
    }
  
    const colors: string[] = [];
    const hue = 210; // Blue hue
    const saturation = 100; // Keep saturation high for vibrant colors
  
    for (let i = 0; i < length; i++) {
      // Ensure lightness is at least 10% to avoid black
      const lightness = 30 + (70 / (length )) * i; // Evenly distributed between 10% and 90%
      colors.push(this.hslToHex(hue, saturation, lightness));
    }
  
    return colors;
  }
  
  // Helper function to convert HSL to HEX
  hslToHex(h: number, s: number, l: number): string {
    s /= 100;
    l /= 100;
  
    const c = (1 - Math.abs(2 * l - 1)) * s;
    const x = c * (1 - Math.abs((h / 60) % 2 - 1));
    const m = l - c / 2;
  
    let r = 0,
      g = 0,
      b = 0;
  
    if (h >= 0 && h < 60) {
      r = c;
      g = x;
      b = 0;
    } else if (h >= 60 && h < 120) {
      r = x;
      g = c;
      b = 0;
    } else if (h >= 120 && h < 180) {
      r = 0;
      g = c;
      b = x;
    } else if (h >= 180 && h < 240) {
      r = 0;
      g = x;
      b = c;
    } else if (h >= 240 && h < 300) {
      r = x;
      g = 0;
      b = c;
    } else if (h >= 300 && h < 360) {
      r = c;
      g = 0;
      b = x;
    }
  
    r = Math.round((r + m) * 255);
    g = Math.round((g + m) * 255);
    b = Math.round((b + m) * 255);
  
    return `#${((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1)}`;
  }
  
}
